"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _fragments = require("./fragments");
Object.keys(_fragments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fragments[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fragments[key];
    }
  });
});
